<template>
  <div class="max-w-6xl mx-auto py-8">
    <UsageDashboard />
  </div>
</template>

<script setup lang="ts">
import UsageDashboard from '@/components/usage/UsageDashboard.vue';
</script>
